module.exports = __webpack_public_path__ + "f9b5d834b2fea5a2b440074e662c2281.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/summernote/dist/font/summernote.woff?dbafe969167589eda84514394d126413
// module id = 1432
// module chunks = 12